import { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, FormGroup, Input, Label, Row } from "reactstrap";

import { encryptStorage } from "../../../../constants/EncryptStorage";
import { GetLanguageString } from "../../../helper/Components";
import SelectUnit from "../../../shared/SelectUnit";
import { ApiUnit } from "../../../unit/ApiUnit";

const selectedUnitType = (unit) => unit?.label1 || unit?.lable1 || "";

const CashBalanceReportFilters = ({
  values,
  setValues,
  onSubmit,
  loading = false,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [draftValues, setDraftValues] = useState(values);
  const excludeExUnit = draftValues?.excludeExUnit !== false;
  const unitType = selectedUnitType(draftValues.unit);
  const isZone = unitType === "Zone" || unitType === "ZoneOS";

  useEffect(() => {
    setDraftValues(values);
  }, [values]);

  useEffect(() => {
    if (draftValues.unit.value === 0) {
      ApiUnit()
        .getUnit(loggedInUnitId, loggedInUnitId, excludeExUnit)
        .then((res) => {
          const temp = res.data.unitList[0];
          setDraftValues((current) => ({
            ...current,
            unit: {
              value: temp.id,
              label: temp.name,
              label1: temp.unitTypeName,
            },
            showSelectedUnitsCheck: "None",
          }));
        })
        .catch((err) => console.log(err));
    }
  }, [loggedInUnitId, excludeExUnit, draftValues.unit.value]);

  const setFilter = (filter) => {
    setDraftValues((current) => ({
      ...current,
      showSelectedUnitsCheck: filter,
    }));
  };

  const handleSearch = () => {
    if (loading) return;
    setValues(draftValues);
    onSubmit(draftValues);
  };

  const active = (filter) =>
    draftValues.showSelectedUnitsCheck === filter ? "primary" : "white";

  return (
    <div className="ibox-content" style={{ overflow: "visible" }}>
      <div style={{ position: "relative", zIndex: 30, overflow: "visible" }}>
        <SelectUnit
          values={draftValues}
          setValues={(next) =>
            setDraftValues({
              ...next,
              showSelectedUnitsCheck: "None",
            })
          }
          unitId={draftValues.unit.value}
          excludeExUnit={excludeExUnit}
          inlineWithArrows
          excludeUnitTypes={["Usra", "UsraMuavin", "Munfarid"]}
        />
      </div>
      <Row className="m-t-md">
        <Col md="12">
          <ButtonGroup>
            {(unitType === "Markaz" ||
              isZone ||
              unitType === "Halqa" ||
              unitType === "Tanzeem") && (
              <Button
                color={active("None")}
                type="button"
                onClick={() => setFilter("None")}
              >
                <GetLanguageString props="report_member_show_all_units" />
              </Button>
            )}
            {(unitType === "Markaz" || isZone) && (
              <Button
                color={active("Halqa")}
                type="button"
                onClick={() => setFilter("Halqa")}
              >
                <GetLanguageString props="report_member_show_halqa" />
              </Button>
            )}
            {(unitType === "Markaz" ||
              isZone ||
              unitType === "Halqa") && (
              <Button
                color={active("Tanzeem")}
                type="button"
                onClick={() => setFilter("Tanzeem")}
              >
                <GetLanguageString props="report_member_show_tanzeem" />
              </Button>
            )}
            {(unitType === "Markaz" ||
              isZone ||
              unitType === "Halqa" ||
              unitType === "Tanzeem") && (
              <Button
                color={active("Usra")}
                type="button"
                onClick={() => setFilter("Usra")}
              >
                <GetLanguageString props="report_member_show_usra" />
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Row className="m-t-md align-items-center">
        <Col md="6">
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                checked={!!draftValues.unitsExceedingLimits}
                onChange={(e) =>
                  setDraftValues({
                    ...draftValues,
                    unitsExceedingLimits: e.target.checked,
                  })
                }
              />{" "}
              <GetLanguageString props="cash_balance_report_exceeding_checkbox" />
            </Label>
          </FormGroup>
        </Col>
        <Col md="6" className="text-right">
          <Button
            color="primary"
            type="button"
            onClick={handleSearch}
            disabled={loading}
            style={{
              minWidth: "120px",
              borderRadius: "8px",
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(26, 179, 148, 0.25)",
            }}
          >
            {<GetLanguageString props="funds_submit" />}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default CashBalanceReportFilters;
